import { BalanceSide } from '@vertex-protocol/contracts';

export function getOrderSubmitButtonSideClassNames({
  disabled,
  isLoading,
  side,
}: {
  disabled: boolean;
  isLoading: boolean;
  side: BalanceSide;
}) {
  if (isLoading || disabled) {
    return 'border-disabled';
  }

  return [
    'border-transparent',
    side === 'long'
      ? 'bg-positive text-text-button-primary'
      : 'bg-negative text-text-button-primary',
  ];
}
